module.exports = __webpack_public_path__ + "img/100-somaliland.c34862b9.svg";